module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modulelayout"
  }, [_vm._t("default"), (_vm.$slots.bottom) ? _c('div', {
    staticClass: "modulelayout__footer"
  }, [_vm._t("bottom")], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328a947f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newprogram/components/modulelayout/ModuleLayout.vue
// module id = 689b28f485d4c9c21d8f
// module chunks = 10